import styled from 'styled-components'

export const CollapseIcon = styled.i`
  position: absolute;
  right: 0;
  top: 2px;
  cursor: pointer;
`
